import { UploadExcel as GenericUploadExcel } from '../../../components/UploadExcel';
import { CustomerService as Service } from './CustomerService';

interface CustomerUploadResult {
    rowNum: number;
    pseudoId?: string;
    partyName?: string;
    success: string;
    error?: string;
}

const resultColumns = [
    { field: 'rowNum', header: 'Dòng dữ liệu', width: 110, dataType: 'number' },
    { field: 'pseudoId', header: 'Mã khách hàng', width: 150 },
    { field: 'partyName', header: 'Tên khách hàng', width: 250 },
    {
        field: 'success', header: 'Kết quả', width: 100, dataType: 'custom', customCell(rowData: any): any {
            if (rowData.success === 'Y') {
                return <p className="m-0"><i className="true-icon pi pi-check-circle mr-1" /><span>Thành công</span></p>;
            }
            return <p className="m-0"><i className="false-icon pi pi-times-circle mr-1" /><span>Thất bại</span></p>;
        }
    },
    {
        field: 'error', header: 'Mô tả lỗi', minWidth: 250, dataType: 'custom', customCell(rowData: any) {
            return <div style={{ whiteSpace: 'pre-wrap' }}>{rowData.error}</div>;
        }
    }
];

export const UploadExcel = ({ display, setDisplay, reloadLazyData }) => {
    return (
        <GenericUploadExcel<CustomerUploadResult>
            display={display}
            setDisplay={setDisplay}
            reloadLazyData={reloadLazyData}
            service={Service}
            header="Upload file Excel khách hàng"
            resultHeader="Kết quả upload Excel khách hàng"
            columns={resultColumns}
        />
    );
};
